module.exports = __webpack_public_path__ + "static/media/cto.3d396c27.png";